import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
import NewsLetter from './SubscribeNewsLetterForm.vue';
import { S3_ASSETS_BUCKET_URL } from '../helpers/constants/LandingPage';
import WhiteLabelRedirectMixin from '../helpers/mixins/WhiteLabelRedirectMixin';
let Footer = class Footer extends Mixins(ViewportSizeMixin, WhiteLabelRedirectMixin) {
    constructor() {
        super(...arguments);
        this.whiteLabelContent = null;
    }
    get brandInvertedLogo() {
        return ((!!this.whiteLabelContent && this.whiteLabelContent.whiteLabelLogo) ||
            `${S3_ASSETS_BUCKET_URL}/chatgenie-logo-landing-beta-inverted.png`);
    }
    get hasWhiteLabel() {
        return !!this.whiteLabelContent;
    }
    get footerCompanyLabel() {
        return (!!this.whiteLabelContent && this.whiteLabelContent.whiteLabelTitle) || `Chatgenie`;
    }
    get currentYear() {
        return moment().format('YYYY');
    }
    get socialLinks() {
        return [
            {
                icon: require('@/assets/icons/icon-fb.svg'),
                link: 'https://www.facebook.com/ChatGenie',
            },
            {
                icon: require('@/assets/icons/icon-tw.svg'),
                link: 'https://twitter.com/chatgenieph',
            },
            {
                icon: require('@/assets/icons/icon-ig.svg'),
                link: 'https://www.instagram.com/chatgenie.ph/',
            },
            {
                icon: require('@/assets/icons/icon-yt.svg'),
                link: 'https://www.youtube.com/channel/UCfI5QDh8PmAiU0outNApCkA',
            },
        ];
    }
    get productLinks() {
        return [
            {
                title: 'Features',
                link: '/features',
                external: false,
            },
            {
                title: 'Merchants',
                link: '/merchants',
                external: false,
            },
            {
                title: 'Pricing',
                link: '/pricing',
                external: false,
            },
            {
                title: 'Grab Express Integration',
                link: '/grab-integration',
                external: false,
            },
            {
                title: 'BPI Integration',
                link: '/bpi-integration',
                external: false,
            },
            {
                title: 'GCash Integration',
                link: '/gcash-integration',
                external: false,
            },
        ];
    }
    get termsOfUseLinks() {
        return [
            {
                title: 'Terms of Use',
                link: '/terms',
                external: false,
            },
            {
                title: 'Privacy Policy',
                link: '/terms',
                external: false,
            },
        ];
    }
    get supportLinks() {
        return [
            {
                title: 'Resources',
                link: 'https://www.youtube.com/channel/UCfI5QDh8PmAiU0outNApCkA',
                external: true,
            },
            {
                title: 'Our Community',
                link: 'https://support.chatgenie.ph/',
                external: true,
            },
            {
                title: 'Blog',
                link: 'https://blog.chatgenie.ph/',
                external: true,
            },
            {
                title: 'Chatgenie Expert Assistance',
                link: '/sales-partner',
                external: false,
            },
            {
                title: 'Become a Sales Partner',
                link: '/sales-partner/get-started',
                external: false,
            },
        ];
    }
    get companyLinks() {
        return [
            {
                title: 'About Us',
                link: '/about',
                external: false,
            },
            {
                title: 'Press',
                link: '/press',
                external: false,
            },
            {
                title: 'Team',
                link: '/team',
                external: false,
            },
        ];
    }
    goTo(link, isExternal) {
        if (isExternal) {
            window.open(link);
        }
        else {
            this.$router.push(link);
        }
    }
};
Footer = __decorate([
    Component({
        components: {
            NewsLetter,
        },
    })
], Footer);
export default Footer;
